import { processMessage } from "./apiService";

// Add user message to the messages list
export const addUserMessage = (message, messages) => {
  const userMessage = {
    id: messages.length + 1,
    text: message,
    sender: "user",
    timestamp: new Date(),
  };

  return [...messages, userMessage];
};

// Add agent message to the messages list
export const addAgentMessage = (text, messages) => {
  const agentMessage = {
    id: messages.length + 1,
    text,
    sender: "agent",
    timestamp: new Date(),
  };

  return [...messages, agentMessage];
};

// Add system message to the messages list
export const addSystemMessage = (text, messages) => {
  const systemMessage = {
    id: messages.length + 1,
    text,
    sender: "system",
    timestamp: new Date(),
  };

  return [...messages, systemMessage];
};

// Process user message and get agent response
export const processUserMessage = async (
  message,
  messages,
  onTypingChange,
  conversationId
) => {
  try {
    // Indicate that the agent is typing
    onTypingChange(true);

    // Get response from API
    const response = await processMessage(message, conversationId);

    // Add agent response
    const updatedMessages = addAgentMessage(response, messages);

    return { success: true, messages: updatedMessages };
  } catch (error) {
    // Add error message
    const errorMessage = `An error occurred: ${error.message}. Please try again or contact support.`;
    const updatedMessages = addAgentMessage(errorMessage, messages);

    return { success: false, messages: updatedMessages, error };
  } finally {
    // Indicate that the agent stopped typing
    onTypingChange(false);
  }
};
